import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight, ChevronDown } from 'lucide-react'
export function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-ocean-900  pt-16 md:pt-0">
      {/* Background Gradient & Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-ocean-900 via-ocean-800 to-navy-900 opacity-90 z-0" />

      {/* Animated Wave Background */}
      <div className="absolute inset-0 z-0 opacity-20">
        <svg
          className="absolute bottom-0 left-0 w-[200%] h-full animate-wave-slow"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path
            fill="#00C9A7"
            fillOpacity="0.3"
            d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
        <svg
          className="absolute bottom-0 left-0 w-[200%] h-full animate-wave-medium"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
          style={{
            animationDirection: 'reverse',
            opacity: 0.5,
          }}
        >
          <path
            fill="#088395"
            fillOpacity="0.4"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,90.7C672,85,768,107,864,133.3C960,160,1056,192,1152,186.7C1248,181,1344,139,1392,117.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{
            opacity: 0,
            y: 30,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.8,
            ease: 'easeOut',
          }}
        >
          <span className="inline-block py-1 px-3 rounded-full bg-ocean-500/20 border border-ocean-500/30 text-ocean-50 text-sm font-medium tracking-wide mb-6 backdrop-blur-sm">
            Next Generation Renewable Energy
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-tight">
            Powering the Future with <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-ocean-500 to-white">
              Ocean Energy
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-ocean-50/80 max-w-3xl mx-auto mb-10 font-light">
            Harnessing the relentless power of waves to deliver reliable, clean
            electricity for coastal communities and island nations.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#technology"
              className="w-full sm:w-auto px-8 py-4 bg-ocean-500 hover:bg-white hover:text-ocean-900 text-navy-900 font-bold rounded-full transition-all duration-300 flex items-center justify-center group"
            >
              Explore Our Technology
              <ArrowRight className="ml-2 h-5 w-5 transform group-hover:translate-x-1 transition-transform" />
            </a>
            {/* <a
              href="#contact"
              className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-white text-white hover:bg-white/10 font-semibold rounded-full transition-all duration-300"
            >
              Partner With Us
            </a> */}
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10"
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
          y: [0, 10, 0],
        }}
        transition={{
          delay: 1,
          duration: 2,
          repeat: Infinity,
        }}
      >
        <a
          href="#about"
          className="text-white/60 hover:text-white transition-colors"
        >
          <ChevronDown className="h-8 w-8" />
        </a>
      </motion.div>
    </section>
  )
}
